var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('titlebar',{attrs:{"title":"Create Campaign"}}),_c('CampaignForm',{attrs:{"loading":_vm.submitting},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }